import { useLazyQuery } from '@apollo/client';
import { apolloClient } from '../utils/apollo';
import { GetContractDocument } from '@upheal/graphql/definitions/contracts/GetContract.generated';
import { WatchQueryFetchPolicy } from '@apollo/client/core/watchQueryOptions';

type Props = {
    fetchPolicy?: WatchQueryFetchPolicy;
};

export const useContractLazy = ({
    fetchPolicy = 'cache-first',
}: Props = {}) => {
    const [fetchContract, { loading: loadingContract }] = useLazyQuery(
        GetContractDocument,
        {
            fetchPolicy,
            client: apolloClient,
        },
    );

    return {
        fetchContract,
        loadingContract,
    };
};
